import { useCallback } from 'react';
import { jsonToCsv } from 'js/utils/csv.util';

export const useTicketDownload = ({ t, rows, data }) => {
    return useCallback(() => {
        const filename = 'ticket.csv';
        const link = document.createElement('a');

        const csv = jsonToCsv([
            rows
                .filter((row) => row[1])
                .map((row) => ({
                    [t('popup.download.field')]: row[0],
                    [t('popup.download.value')]: row[1]
                })),
            data.slice(1)
                .map((dataRow) => ({
                    [t('popup.eventName')]: `${dataRow[0][0]} (${dataRow[0][1]})`,
                    [t('popup.eventStartTime')]: dataRow[1],
                    [t('popup.leagueName')]: dataRow[2] ?? '',
                    [t('popup.expectedResult')]: dataRow[3]
                }))
        ]);

        link.setAttribute('download', filename);
        link.setAttribute('href', csv);
        link.click();
    },
    [
        t,
        rows,
        data
    ]);
};
